import { render, staticRenderFns } from "./SimulationDetailsTab.vue?vue&type=template&id=30033b92&scoped=true&"
import script from "./SimulationDetailsTab.vue?vue&type=script&lang=js&"
export * from "./SimulationDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30033b92",
  null
  
)

export default component.exports